import { Box } from "@outschool/backpack";
import {
  ActivityOverview_ActivityFragment,
  ActivityOverview_LeaderFragment,
} from "@outschool/gql-frontend-generated";
import { gql } from "@outschool/ui-apollo";
import { TeacherNameAndRatings } from "@outschool/ui-components-website";
import React from "react";

interface ActivityOverviewProps {
  activity: ActivityOverview_ActivityFragment;
  leader: ActivityOverview_LeaderFragment;
  onClickViewTeacher?: (event: React.SyntheticEvent) => void;
}

export default function ActivityOverview({
  leader,
  onClickViewTeacher,
}: ActivityOverviewProps) {
  return (
    <Box>
      <TeacherNameAndRatings
        leader={leader}
        onClickViewTeacher={onClickViewTeacher}
      />
    </Box>
  );
}

ActivityOverview.fragments = {
  activity: gql`
    fragment ActivityOverview_activity on Activity {
      uid
      completedEnrollmentCount
      reviewCount
      averageStarRating
      isClub
      title
    }
  `,
  leader: gql`
    fragment ActivityOverview_leader on Leader {
      uid
      name
      suspended_at
      teacher_approved_at
      reviewCount
      averageActivityStarRating
      photo
      leader_link
      details {
        headline
        about
      }
      video {
        file {
          url
          thumbUrl
        }
      }
      educatorTiers
      credentials {
        uid
        degreeType
        degreeSubject
        certificateDiscipline
        otherType
        certificateState
        name
        degreeInstitution
        degreeAdditionalInfo
      }
      ownerOfSellerOrg {
        uid
      }
    }
  `,
};
